// Mobile top bar — only visible below the lg breakpoint. Contains the
// hamburger that opens the sidebar drawer.
import React from 'react';
import { Menu } from 'lucide-react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_call-quality-grade/artifacts/ehb854bc_1.Landscape.png';

export const MobileHeader = ({ onOpen }) => (
  <div className="sticky top-0 z-30 flex items-center justify-between px-4 py-4 bg-white border-b border-slate-200 lg:hidden">
    <button onClick={onOpen} data-testid="open-sidebar-btn">
      <Menu className="w-6 h-6 text-slate-600" />
    </button>
    <img src={LOGO_URL} alt="Yabbit Logo" className="h-8 w-auto object-contain" />
    <div className="w-6" />
  </div>
);
